import moment from 'moment';
import 'moment/locale/de';
import 'moment/locale/fr';
import 'moment/locale/nl';
import 'moment/locale/es';

const I18n = (window.I18n = require('./i18n.js'));
require('./translations.js');
delete window.I18n;

I18n.fallbacks = true;
I18n.defaultLocale = 'en';

I18n.supportedLocales = Object.keys(I18n.translations);

I18n.isLocaleSupported = (locale) => I18n.supportedLocales.includes(locale);

I18n.setLocale = (locale) => {
  if (I18n.isLocaleSupported(locale)) {
    I18n.locale = locale;
    moment.locale(locale);
    moment.updateLocale('en', {
      monthsShort: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
    });
    if (locale === 'de') {
      moment.updateLocale('de', {
        monthsShort: [
          'Jan',
          'Feb',
          'Mär',
          'Apr',
          'Mai',
          'Juni',
          'Juli',
          'Aug',
          'Sep',
          'Okt',
          'Nov',
          'Dez',
        ],
      });
    }
    if (locale === 'es') {
      moment.updateLocale('es', {
        monthsShort: [
          'ene',
          'feb',
          'mar',
          'abr',
          'may',
          'jun',
          'jul',
          'ago',
          'sep',
          'oct',
          'nov',
          'dic',
        ],
      });
    }
    if (locale === 'fr') {
      moment.updateLocale('fr', {
        monthsShort: [
          'jan.',
          'fév.',
          'mar.',
          'avr.',
          'mai',
          'juin',
          'juil.',
          'août',
          'sept.',
          'oct.',
          'nov.',
          'déc.',
        ],
      });
    }
    if (locale === 'nl') {
      moment.updateLocale('nl', {
        monthsShort: [
          'jan',
          'feb',
          'mrt',
          'apr',
          'mei',
          'jun',
          'jul',
          'aug',
          'sep',
          'okt',
          'nov',
          'dec',
        ],
      });
    }
  }
};

export default I18n;
